import api from '@/api/products-enabled'
import baseModule from '@/store/shared/graphql'

const STORE_TYPE = 'PRODUCTS_ENABLED'
const API_DATA_KEY = 'productsEnabled'
const API_DATA_BY_ID_KEY = 'productId'
const defaultModule = baseModule(STORE_TYPE, API_DATA_BY_ID_KEY, API_DATA_KEY, api)

export default {
    state: {
        ...defaultModule.state,
    },
    getters: {
        ...defaultModule.getters,
    },
    mutations: {
        ...defaultModule.mutations,
    },
    actions: {
        ...defaultModule.actions,
    },
    namespaced: true,
}
